export const HttpMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
};

const ApiRoutes = {
  Auth: {
    Login: {
      Endpoint: "/auth/login",
      Method: HttpMethod.Post,
    },
    Logout: {
      Endpoint: "/auth/logout",
      Method: HttpMethod.Get,
    },
  },

  Cafe: {
    Create: { Endpoint: "/admin/cafe/", Method: HttpMethod.Post },
    GetById: { Endpoint: (id) => `/admin/cafe/${id}`, Method: HttpMethod.Get },
  },

  CafeImages: {
    SetCover: {
      Endpoint: (id) => `/admin/cafeupload/${id}/cover`,
      Method: HttpMethod.Post,
    },
    UploadDocument: {
      Endpoint: (id) => `/admin/cafeupload/${id}/documents`,
      Method: HttpMethod.Post,
    },
    DeleteDocument: {
      Endpoint: (id, docId) => `/admin/cafeupload/${id}/documents/${docId}`,
      Method: HttpMethod.Delete,
    },
    UploadGallery: {
      Endpoint: (id) => `/admin/cafeupload/${id}/images`,
      Method: HttpMethod.Post,
    },
    DeleteGallery: {
      Endpoint: (id, imgId) => `/admin/cafeupload/${id}/images/${imgId}`,
      Method: HttpMethod.Delete,
    },
    UploadMenu: {
      Endpoint: (id) => `/admin/cafeupload/${id}/menu-images`,
      Method: HttpMethod.Post,
    },
    DeleteMenu: {
      Endpoint: (id, imgId) => `/admin/cafeupload/${id}/menu-images/${imgId}`,
      Method: HttpMethod.Delete,
    },
  },

  GetAllCafes: { Endpoint: "/admin/cafe/", Method: HttpMethod.Get },

  UpdateStatus: {
    Endpoint: (id) => `/admin/cafe/${id}/status`,
    Method: HttpMethod.Patch,
  },

  KYC: {
    GetAll: { Endpoint: "/admin/kyc", Method: HttpMethod.Get },
    GetById: {
      Endpoint: (userId) => `/admin/kyc/${userId}`,
      Method: HttpMethod.Get,
    },
    Approve: {
      Endpoint: (userId) => `/admin/kyc/${userId}/approve`,
      Method: HttpMethod.Post,
    },
    Reject: {
      Endpoint: (userId) => `/admin/kyc/${userId}/reject`,
      Method: HttpMethod.Post,
    },
    Update: {
      Endpoint: `/admin/kyc/update`,
      Method: HttpMethod.Post,
    },
    GetDocument: {
      Endpoint: (imageId, userId) =>
        `/admin/kyc/document/${imageId}?userId=${userId}`,
      Method: HttpMethod.Get,
    },
    DownloadAll: {
      Endpoint: (userId) => `/admin/kyc/download-all/${userId}`,
      Method: HttpMethod.Get,
    },
  },

  Investment: {
    GetAll: { Endpoint: "/admin/investment/", Method: HttpMethod.Get },
    GetById: {
      Endpoint: (id) => `/admin/investment/${id}`,
      Method: HttpMethod.Get,
    },
    Approve: {
      Endpoint: (id) => `/admin/investment/${id}/approve`,
      Method: HttpMethod.Post,
    },
    Reject: {
      Endpoint: (id) => `/admin/investment/${id}/reject`,
      Method: HttpMethod.Post,
    },
  },
  Referral: {
    Overview: {
      Endpoint: "/admin/referral/overview",
      Method: HttpMethod.Get,
    },
    Earnings: {
      Endpoint: "/admin/referral/earnings",
      Method: HttpMethod.Get,
    },
    Team: {
      Endpoint: "/admin/referral/team",
      Method: HttpMethod.Get,
    },
    Tree: {
      Endpoint: "/admin/referral/tree",
      Method: HttpMethod.Get,
    },
    Payout: {
      Endpoint: "/admin/referral/payout-schedule",
      Method: HttpMethod.Post,
    },
    DistributeProfit: {
      Endpoint: "/admin/referral/distribute-profit",
      Method: HttpMethod.Post,
    },
  },
  Share: {
    List: {
      Endpoint: "/admin/share",
      Method: HttpMethod.Get,
    },
  },
  User: {
    List: {
      Endpoint: "/admin/user/list",
      Method: HttpMethod.Get,
    },
    GetById: {
      Endpoint: (id) => `/admin/user/${id}`,
      Method: HttpMethod.Get,
    },
    ToggleStatus: {
      Endpoint: (id) => `/admin/user/${id}/toggle-status`,
      Method: HttpMethod.Put,
    },
    Delete: {
      Endpoint: (id) => `/admin/user/${id}`,
      Method: HttpMethod.Delete,
    },
    ChangePasswordDirect: {
      Endpoint: "/user/change-password-direct",
      Method: HttpMethod.Patch,
    },
  },
  Contact: {
    List: {
      Endpoint: "/admin/contact",
      Method: HttpMethod.Get,
    },
    Delete: {
      Endpoint: (id) => `/admin/contact/${id}`,
      Method: HttpMethod.Delete,
    },
  },
  Role: {
    List: {
      Endpoint: "/admin/roles",
      Method: HttpMethod.Get,
    },
    Create: {
      Endpoint: "/admin/roles",
      Method: HttpMethod.Post,
    },
    AssignPermissions: {
      Endpoint: "/admin/roles/assign-permissions",
      Method: HttpMethod.Post,
    },
    AssignUserRoles: {
      Endpoint: "/admin/roles/assign-user-roles",
      Method: HttpMethod.Put,
    },
    ListPermissions: {
      Endpoint: "/admin/roles/permissions",
      Method: HttpMethod.Get,
    },
    CreatePermission: {
      Endpoint: "/admin/roles/permissions",
      Method: HttpMethod.Post,
    },
    SeedPermissions: {
      Endpoint: "/admin/roles/permissions/seed",
      Method: HttpMethod.Post,
    },
    GetRolePermissions: (id) => ({
      Endpoint: `/admin/roles/${id}/permissions`,
      Method: HttpMethod.Get,
    }),
    Update: (id) => ({
      Endpoint: `/admin/roles/${id}`,
      Method: HttpMethod.Patch,
    }),
    Delete: (id) => ({
      Endpoint: `/admin/roles/${id}`,
      Method: HttpMethod.Delete,
    }),
    UnassignUserRole: (userId, roleId) => ({
      Endpoint: `/admin/roles/user/${userId}/role/${roleId}`,
      Method: HttpMethod.Delete,
    }),
    CreateStaff: {
      Endpoint: "/admin/roles/create-staff",
      Method: HttpMethod.Post,
    },
    MyPermissions: {
      Endpoint: "/admin/roles/my-permissions",
      Method: HttpMethod.Get,
    },
  },
};

export default ApiRoutes;
